import moment from "moment";

export const  GetPartyStatusId = (dob?: Date, bookEndDate?: Date): number => {
    //1-Adult;2-Child;3-Infant
    if (bookEndDate === undefined || dob === undefined) {
        return 1;
    }
    let age = moment(bookEndDate, "DD-MM-YYYY").year() - moment(dob, "YYYY-MM-DD").year();
    return age <= 2 ? 3 : age <= 12 ? 2 : 1
}